// function to formate Amount for dashboard
export function formatAmount(amount) {
    if (!amount) {
        return {
            value: '0',
            label: ''
        }
    }
    if (amount < 100000) {
        return {
            value: amount.toString(),
            label: ''
        }
    }

    const lakh = 100000;
    const crore = 10000000;

    if (amount >= crore) {
        // Format for amounts >= 1 crore
        const crores = Math.floor(amount / crore); // Get whole crores
        const remaining = amount % crore; // Remainder in the lakh range
        const lakhs = Math.floor(remaining / lakh); // Get whole lakhs from the remainder
        if (lakhs > 0) {
            return {
                value: `${crores}.${lakhs}`,
                label: 'Cr+'
            }
        } else {
            return {
                value: `${crores}`,
                label: 'Cr+'
            }
        }
    } else if (amount >= lakh) {
        // Format for amounts >= 1 lakh but < 1 crore
        const lakhs = Math.floor(amount / lakh); // Get whole lakhs
        const thousands = Math.floor((amount % lakh) / 1000); // Get remaining thousands
        if (thousands > 0) {
            return {
                value: `${lakhs}.${thousands}`,
                label: 'Lac+'
            }
        } else {
            return {
                value: `${lakhs}`,
                label: 'Lac+'
            }
        }
    }
}

